import { ReduxHelper } from "helpers";
import { IApiResponse, IAuditTrail, IGetAuditTrailRequest } from "model";

export const prefix = "AUDIT_TRAIL";
export const getAllAuditTrail = ReduxHelper.generateActions<
  IGetAuditTrailRequest,
  IApiResponse<IAuditTrail[]>
>(prefix, "GET_ALL_AUDIT_TRAIL");

export const clearReducer = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_REDUCER"
);
